import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSwipeable } from 'react-swipeable';
import { GatsbyImage } from 'gatsby-plugin-image';

const StyledContactCarousel = styled.div`
  .carousel {
    overflow: hidden;
    position: relative;
  }
  .inner {
    white-space: nowrap;
    transition: transform 0.3s;
    margin-bottom: -0.5rem;
  }
`;

const StyledContactCarouselItem = styled.figure`
  display: inline-flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .carousel-image {
    object-fit: cover;
    overflow: hidden;
  }

  .employee-info {
    display: flex;
    width: 101%;
    flex-direction: column;
    background: var(--white);
    padding: 1rem;
    position: relative;
    margin-top: -4rem;
  }

  .employee-name {
    color: var(--primary);
    padding-bottom: 0.25rem;
  }

  .employee-title {
    color: var(--black);
  }
`;

export const ContactCarouselItem = ({ src, alt, heading, description }) => {
  return (
    <StyledContactCarouselItem>
      <GatsbyImage
        image={src}
        alt={alt}
        className="carousel-image"
        blurDataURL={src?.placeholder?.fallback}
      />
      {(heading || description) && (
        <figcaption className="employee-info">
          <p className="heading-s-regular employee-name">{heading}</p>
          <p className="body-m-regular employee-title">{description}</p>
        </figcaption>
      )}
    </StyledContactCarouselItem>
  );
};

const ContactCarousel = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  // const [paused, setPaused] = useState(false);

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }

    setActiveIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      // if (!paused) {
      updateIndex(activeIndex + 1);
      // }
    }, 3000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  });

  const handlers = useSwipeable({
    onSwipedLeft: () => updateIndex(activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1),
  });

  return (
    <StyledContactCarousel>
      <div
        {...handlers}
        className="carousel"
        // onMouseEnter={() => setPaused(true)}
        // onMouseLeave={() => setPaused(false)}
      >
        <div className="inner" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
          {React.Children.map(children, (child, index) => {
            return React.cloneElement(child);
          })}
        </div>
      </div>
    </StyledContactCarousel>
  );
};

export default ContactCarousel;
